import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, YoutubeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-gray-300 pt-16 pb-8 border-t border-gray-800" data-id="element-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12" data-id="element-32">
          {/* Brand Column */}
          <div className="lg:col-span-2" data-id="element-33">
            <a href="/" className="inline-block mb-6" data-id="element-34">
              <img src="https://cdn.magicpatterns.com/uploads/g1ZUhAWEqbLcGxsd7WaXTY/logo.png" alt="TKDScore.com Logo" className="h-12 w-auto" data-id="element-35" />
            </a>
            <p className="text-gray-400 mb-6 max-w-sm" data-id="element-36">
              The official distributor of Daedo electronic scoring equipment.
              Equipping elite athletes, schools, and tournaments with the best
              gear in Taekwondo.
            </p>
            <div className="flex space-x-4" data-id="element-37">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors" data-id="element-38">
                <FacebookIcon className="w-5 h-5" data-id="element-39" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-400 hover:text-white transition-colors" data-id="element-40">
                <TwitterIcon className="w-5 h-5" data-id="element-41" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-pink-600 hover:text-white transition-colors" data-id="element-42">
                <InstagramIcon className="w-5 h-5" data-id="element-43" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-red-600 hover:text-white transition-colors" data-id="element-44">
                <YoutubeIcon className="w-5 h-5" data-id="element-45" />
              </a>
            </div>
          </div>

          {/* Shop Column */}
          <div data-id="element-46">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-47">
              Shop
            </h4>
            <ul className="space-y-3" data-id="element-48">
              <li data-id="element-49">
                <a href="#daedo-pss-systems" className="hover:text-blue-400 transition-colors" data-id="element-50">
                  Daedo PSS Systems
                </a>
              </li>
              <li data-id="element-51">
                <a href="#daedo-products" className="hover:text-blue-400 transition-colors" data-id="element-52">
                  Daedo Products
                </a>
              </li>
              <li data-id="element-53">
                <a href="#wacoku-products" className="hover:text-blue-400 transition-colors" data-id="element-54">
                  Wacoku Products
                </a>
              </li>
            </ul>
          </div>

          {/* Support Column */}
          <div data-id="element-55">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-56">
              Support
            </h4>
            <ul className="space-y-3" data-id="element-57">
              <li data-id="element-58">
                <a href="https://www.daedosupport.com/portal/en/kb/tkd-score" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors" data-id="element-59">
                  Contact Us
                </a>
              </li>
              <li data-id="element-60">
                <a href="https://www.daedosupport.com/portal/en/kb/tkd-score" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors" data-id="element-61">
                  Create Ticket
                </a>
              </li>
              <li data-id="element-62">
                <a href="#support-software" className="hover:text-blue-400 transition-colors" data-id="element-63">
                  Software Downloads
                </a>
              </li>
              <li data-id="element-64">
                <a href="#support-thresholds" className="hover:text-blue-400 transition-colors" data-id="element-65">
                  Hit Thresholds
                </a>
              </li>
              <li data-id="element-66">
                <a href="#returns" className="hover:text-blue-400 transition-colors" data-id="element-67">
                  Returns & Exchanges
                </a>
              </li>
              <li data-id="element-68">
                <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-69">
                  Shipping Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Account Column */}
          <div data-id="element-70">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-71">
              Account
            </h4>
            <ul className="space-y-3" data-id="element-72">
              <li data-id="element-73">
                <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-74">
                  My Account
                </a>
              </li>
              <li data-id="element-75">
                <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-76">
                  Order History
                </a>
              </li>
              <li data-id="element-77">
                <a href="#financing" className="hover:text-blue-400 transition-colors" data-id="element-78">
                  Financing
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-79">
          <p className="text-sm text-gray-500 mb-4 md:mb-0" data-id="element-80">
            &copy; {new Date().getFullYear()} TKDScore.com. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm text-gray-500" data-id="element-81">
            <a href="#" className="hover:text-white transition-colors" data-id="element-82">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-83">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}